@if (division) {
  <a id="dashboardBtn" mat-button [routerLink]="hasWatsonData ? '/warehouses/' + division._id + '/stats' : null" routerLinkActive="active" [disabled]="!hasWatsonData">
    <mat-icon id="dashboardBtnIcon">insert_chart_outlined</mat-icon>
    <span id="dashboardBtnText">{{ 'watson.nav.dashboard' | translate }}</span>
  </a>
  <a id="layoutBtn" mat-button [routerLink]="hasWatsonData ? '/warehouses/' + division._id + '/layout' : null" routerLinkActive="active" [disabled]="!hasWatsonData">
    <mat-icon id="layoutBtnIcon">place</mat-icon>
    <span id="layoutBtnText">{{ 'watson.nav.layout' | translate }}</span>
  </a>
  <a id="uprightsBtn" mat-button [routerLink]="hasWatsonData ? '/warehouses/' + division._id + '/assets' : null" routerLinkActive="active" [disabled]="!hasWatsonData">
    <mat-icon id="uprightsBtnIcon">vertical_split</mat-icon>
    <span id="uprightsBtnText">{{ 'watson.nav.assets' | translate }}</span>
  </a>
  @if (hasCertificationInfos) {
    <a id="systemsBtn" mat-button [routerLink]="'/warehouses/' + division._id + '/systems'" routerLinkActive="active">
      <mat-icon id="systemsBtnIcon">view_quilt</mat-icon>
      <span id="systemsBtnText">{{ 'watson.nav.systems' | translate }}</span>
    </a>
  }
  <div class="sidebar-menu-item">
    <a
      id="issuesBtn"
      mat-button
      [routerLink]="hasWatsonData ? '/warehouses/' + division._id + '/issues' : null"
      routerLinkActive="active"
      [disabled]="!hasWatsonData"
      (press)="issuesSavedSearchMenu?.openMenu($event)"
    >
      <mat-icon id="issuesBtnIcon">ballot</mat-icon>
      <span id="issuesBtnText">{{ 'watson.nav.issues' | translate }}</span>
    </a>
    <app-saved-search-menu #issuesSavedSearchMenu class="addon" [division]="division" [savedSearch]="savedSearch"></app-saved-search-menu>
  </div>
  <ng-container *appIfOnline>
    <a
      *appShowOnRepairMode
      id="repairsBtn"
      mat-button
      [routerLink]="hasWatsonData ? '/warehouses/' + division._id + '/repairs' : null"
      routerLinkActive="active"
      [disabled]="!hasWatsonData"
  >
      <mat-icon id="repairsBtnIcon">handyman</mat-icon>
      <span id="repairsBtnText">{{ 'watson.nav.repairs' | translate }}</span>
    </a>
  </ng-container>
  <a id="inspectionsBtn" mat-button [routerLink]="hasWatsonData ? '/warehouses/' + division._id + '/inspections' : null" routerLinkActive="active" [disabled]="!hasWatsonData">
    <mat-icon id="inspectionsBtnIcon">list_alt</mat-icon>
    <span id="inspectionsBtnText">{{ 'watson.nav.inspections' | translate }}</span>
  </a>
  @if (storageEnabled && (['GSR_STORAGE_ADMIN', 'GSR_STORAGE_USER'] | userRole | async)) {
    <a id="storageBtn" mat-button routerLinkActive="active" [routerLink]="'/storage/' + division._id">
      <mat-icon id="storageBtnIcon">snippet_folder</mat-icon>
      <span id="storageBtnText">{{ 'watson.nav.storage' | translate }}</span>
    </a>
  }
  <a id="detailsBtn" appDisabledOffline mat-button [routerLink]="'/stax/organizations/' + division.organization._id" [queryParams]="{ division: division._id }">
    <mat-icon id="detailsBtnIcon">device_hub</mat-icon>
    <span id="detailsBtnText">{{ 'watson.nav.details' | translate }}</span>
  </a>
}
